import Act from '../actions';

const initState = {};

const testReducer = (state = initState, action) => {
	switch (action.type) {
		case Act.TEST_INFO:
			return { ...state, ...action.payload };
		default:
			return state;
	}
};

export default testReducer;
